export const CONTACT = [
  ["Teléfono", "+41 76 262 42 13", "tel:+41762624213"],
  ["Correo electrónico", "editorialharvest@gmail.com", "mailto:editorialharvest@gmail.com"],
  ["Sitio web", "www.editorialharvest.com", "https://www.editorialharvest.com"],
];

export const ADDRESS = { lines: ["Editorial Harvest", "Una división de Neho Consulting Group Sàrl", "Rue de Vermont 9A", "1202 Ginebra, Suiza"], contact: CONTACT };

export const idRows = (addrLabel, webValue) => [
  ["Nombre comercial", "Editorial Harvest"],
  ["Titular", "Neho Consulting Group Sàrl"],
  ["Identificación empresarial (IDE/UID)", "CHE-450.433.604"],
  [addrLabel, "Rue de Vermont 9A, 1202 Ginebra, Suiza"],
  [addrLabel === "Domicilio" ? "Teléfono de atención al cliente" : "Teléfono", "+41 76 262 42 13", "tel:+41762624213"],
  ["Correo electrónico", "editorialharvest@gmail.com", "mailto:editorialharvest@gmail.com"],
  ["Sitio web", webValue, "https://www.editorialharvest.com"],
];
